import { createAPIActions, createActions, createCustomActions } from '../../utils/redux-actions';

export const observation = createAPIActions('OBSERVATION');
export const observationFollow = createActions('OBSERVATION/FOLLOW');
export const activeObservation = createCustomActions('ACTIVE_OBSERVATION', ['SET', 'CLEAR']);
